import React from 'react';
import {
  Tooltip,
  Icon,
  Icons,
  Typography,
  styled,
} from '@nextiva/next-ui-components';
import { formattedLicensePricingDataType } from 'types/purchaseLicenseModalTypes';

const StyledContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  background-color: #f8f8f8;
  padding: 20.5px 16px 20.5px 16px;
`;
const StyledFlexItem = styled('div')`
  display: flex;
  align-items: center;
`;
const StyledText = styled(Typography)`
  color: ${({ theme }) => theme.palette.secondary.contrastText};
`;
const StyledHelpIcon = styled(Icon)`
  fill: ${({ theme }) => theme.palette.blueGrey.A400};
  margin-left: 12px;
`;

const TOOLTIP_TEXT =
  'The total due today is prorated and does not include the estimated taxes and fees.';
const LABEL_TEXT = 'Total due today';

interface ITotalDue {
  formattedLicensePricingData: formattedLicensePricingDataType;
  didInitialLicensePricingDataApiCallFail: boolean;
}

export const TotalDue = ({
  formattedLicensePricingData,
  didInitialLicensePricingDataApiCallFail,
}: ITotalDue) => (
  <StyledContainer>
    <StyledFlexItem>
      <StyledText variant="h6">{LABEL_TEXT}</StyledText>
      <Tooltip placement="top" title={TOOLTIP_TEXT}>
        <StyledHelpIcon
          icon={Icons.help}
          aria-label="Total Due"
          data-testid="PlatformAdminUI-PurchaseLicenseModal-TotalDueHelpIcon"
        />
      </Tooltip>
    </StyledFlexItem>
    <StyledFlexItem>
      <StyledText variant="h6">
        {didInitialLicensePricingDataApiCallFail
          ? '$--'
          : formattedLicensePricingData?.totalDueToday}
      </StyledText>
    </StyledFlexItem>
  </StyledContainer>
);
